import type { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

type PageContainerProps = {
	children: ReactNode;
};

const PageContainer: FC<PageContainerProps> = ({ children }) => (
	<main className={styles.container}>{children}</main>
);

export default PageContainer;
